var map = {
	"./Aldabra.jpg": 5667,
	"./DeepTimeTrilogy.png": 194,
	"./MAFrontCover.png": 1187,
	"./WolfgangGrulke-Business.jpg": 9961,
	"./WolfgangGrulke-Contact.png": 3358,
	"./WolfgangGrulke.jpeg": 5485,
	"./bookAdornedByNature.png": 7787,
	"./bookBeyondExtinction3D.png": 7788,
	"./bookHeteromorph.png": 1210,
	"./bookNautilus.png": 8603,
	"./nautilus.spiral.png": 6979
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9640;